module.exports = __webpack_public_path__ + "img/BRCA4_Mast.6c9706b0.png";